import { render } from "./SchedulesDetailsHeader.vue?vue&type=template&id=53b28063&scoped=true"
import script from "./SchedulesDetailsHeader.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsHeader.vue?vue&type=script&lang=js"

import "./SchedulesDetailsHeader.vue?vue&type=style&index=0&id=53b28063&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b28063"]])

export default __exports__